<template>
    <div v-if="!typeFlag && show" class="upload_box_components" @click="openModal"
        :style="{width: (typeof width == 'number' ? width + 'px' : width) ,height: (typeof height == 'number' ? height + 'px' : height)}">
        <slot name="upload">
            <div class="up_bx">
                <CloseCircleOutlined v-if="image.trim() && !disabled" @click.stop="deleteIcon" />
                <a-image :preview="disabled" :width="width" :height="height" :src="image"
                    :fallback="require('@/assets/image/defaultImg.png')" />
                <span class="upload_text" v-if="!image.trim()">{{disabled ? '' : text}}</span>
            </div>
        </slot>
    </div>
    <a-modal :maskClosable="false" v-model:visible="visible" title="选择文件" :width="920" @cancel="cancel">
        <div class="select_upload_box">
            <div class="s_u_b_head">
                <div class="s_u_b_h_left">
                    <a-input allowClear placeholder="请输入关键词" v-model:value="keyword"></a-input>
                    <a-button type="primary" @click="imageList()">搜索</a-button>
                </div>
                <div class="s_u_b_h_right">
                    <a-upload :fileList="[]" name="file" multiple :show-upload-list="false" :accept="accept"
                        :customRequest="customRequest" @change="handleChange">
                        <a-button type="primary">上传文件</a-button>
                    </a-upload>
                </div>
            </div>
            <div class="flex me_box">
                <div class="men_left">
                    <div class="m_l_menu">
                        <a-menu v-model:selectedKeys="group_id" style="width: 120px" mode="inline" @click="handleClick">
                            <a-menu-item :key="item.value" v-for="item in groupList">
                                {{item.label ? item.label: item.name}}
                            </a-menu-item>
                        </a-menu>
                    </div>
                    <a-button type="primary" @click="visibleAddimg = true">新增分组</a-button>
                </div>
                <div class="s_u_b_contain">
                    <div class="s_img_box" :class="{s_img_box_select : selectAll && determineFun(item)}"
                        v-for="(item,index) in data" :key="index" @click="selectImg(item)">
                        <img class="is_img" v-if="/\.(png|jpg|gif|jpeg|webp)$/i.test(item.url)" :src="item.url" alt="">
                        <img class="is_img" v-else :src="item.icon" alt="">
                        <div class="is_t_s">
                            <!-- <span class="is_type">
                                {{item.mime}}
                            </span> -->
                            <span class="is_size">
                                {{item.size}}
                            </span>
                        </div>
                        <div class="foot_text">
                            {{item.name}}
                        </div>
                        <div class="rount_select">
                            <a-tooltip placement="top">
                                <template #title>
                                    <span>修改图片分组</span>
                                </template>
                                <div class="iconfont icon-bianji1" @click.stop="setGroup(item)"></div>
                            </a-tooltip>
                        </div>
                    </div>
                    <div class="no_data" v-if="data.length == 0">
                        <img src="@/assets/image/noneData.png" alt="">
                        <span>暂无数据</span>
                    </div>
                </div>
            </div>

            <a-pagination size="small" @change="change" v-model:current="pageInfo.current" :pageSize="pageInfo.pageSize"
                :total="pageInfo.total" :showSizeChanger="false" />

        </div>
        <template #footer>
            <a-button type="primary" v-if="selectAll" @click="handleOk">确认</a-button>
        </template>
    </a-modal>

    <a-upload
        :style="{width: (typeof width == 'number' ? width + 'px' : width) ,height: (typeof height == 'number' ? height + 'px' : height)}"
        ref="uploadRefsCompone" class="upload_box_components" :disabled="disabled" v-if="typeFlag"
        :show-upload-list="false" :accept="accept" :customRequest="customRequest">
        <slot name="upload">
            <div class="up_bx">
                <CloseCircleOutlined v-if="image.trim() && !disabled" @click.stop="deleteMp4" />
                <a-image :preview="disabled" :width="width" :height="height" :src="image"
                    :fallback="require('@/assets/image/defaultImg.png')" />
                <span class="upload_text" v-if="!image.trim()">{{disabled ? '' : text}}</span>
                <div class="u_b_mask" v-if="video" @click.stop>
                    <span class="iconfont icon-bofang" @click.stop="playVideo"></span>
                </div>
            </div>
        </slot>
    </a-upload>

    <a-modal :maskClosable="false" v-model:visible="visibleGroup" title="修改图片分组" @ok="handleGroupOk" @cancel="handleGroupCancel">
        <a-form :model="group_form" ref="group_ref">
            <a-form-item label="分组名称" name="group_id" :rules="[{required:true,message:'请选择分组',trigger:true}]">
                <a-select v-model:value="group_form.group_id">
                    <a-select-option v-for="item in groupList" :value="item.value" :key="item.value">
                        {{item.label ? item.label: item.name}}
                    </a-select-option>
                </a-select>
            </a-form-item>
        </a-form>
    </a-modal>


    <a-modal :maskClosable="false" v-model:visible="visibleAddimg" :title="'新增图片分组'" @ok="handleAddgroupOk" @cancel="Addgroupcancel">
        <SubmitForm ref="submitForm" :labelCol="{span:6}" :form_data="oper_form_data" v-model:form="group_form"
            :is_button="false">
        </SubmitForm>
    </a-modal>
</template>

<script>
    import {
        imageList,
        uploadFile,
        ossFile,
        uploadBaseImage,
        getGroupCate,
        editFile,
        AddGroup
    } from '@/api/common/public.js'
    import {
        CloseCircleOutlined
    } from '@ant-design/icons-vue'
    import {
        message
    } from 'ant-design-vue'
    import PropTypes from 'ant-design-vue/es/_util/vue-types'
    import md5 from 'js-md5'
    import axios from 'axios'
    export default {
        components: {
            CloseCircleOutlined
        },
        emits: ['selectImg', 'selectVideo'],
        props: {
            url: {
                type: String,
                default: ''
            },
            width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).def(100),
            height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).def(100),
            type: {
                type: String,
                default: 'png,jpg,gif,jpeg,webp'
            },
            selectAll: { // 是否多选
                type: Boolean,
                default: false
            },
            number: { // 配合 selectAll 使用 限制选择的数量
                type: Number,
                default: 10
            },
            count: { // 配合 number 使用 限制选择的数量 
                type: Number,
                default: 0
            },
            disabled: {
                type: Boolean,
                default: false
            },
            show: { // 是否显示选择图片的框
                type: Boolean,
                default: true
            },
            text: {
                type: String,
                default: '上传图片'
            },
            videoUrl: {
                type: String,
                default: ''
            }
        },
        data() {
            return {
                image: '  ',
                visible: false,
                keyword: '',
                pageInfo: {
                    current: 1,
                    total: 1,
                    pageSize: 15,
                },
                data: [],
                urlArr: [],
                accept: '.png,.jpg,.gif,.jpeg,.webp',
                editorFun: null,
                video: '',
                groupList: [],
                group_id: [],
                visibleGroup: false,
                group_form: {},
                oper_form_data: [{
                    type: 'input',
                    label: '分组名称',
                    name: 'name',
                    rules: [{
                        required: true,
                        message: '请输入分组名称',
                        trigger: 'change'
                    }],
                    width: '100%'
                }, ],
                visibleAddimg: false,
                fileUploadList: {
                    file: [],
                    uid: []
                }
            }
        },
        created() {},
        watch: {
            url: {
                handler(newValue) {
                    if (newValue) {
                        this.image = newValue
                    } else {
                        this.image = ' '
                    }
                },
                immediate: true
            },
            videoUrl: {
                handler(newValue) {
                    if (newValue) {
                        if (newValue != this.video) {
                            this.video = newValue
                            this.captureFirstFrame()
                        }
                    } else {
                        this.video = ''
                    }
                },
                immediate: true
            },
            type: {
                handler(newValue) {
                    let arr = newValue.split(',')
                    let fie = arr.filter(item => ['png', 'jpg', 'gif', 'jpeg', 'webp'].indexOf(item) != -1)
                    if (fie.length) {
                        this.accept = '.png,.jpg,.gif,.jpeg,.webp'
                    } else {
                        this.accept = arr.map(item => '.' + item).join(',')
                    }
                },
                immediate: true
            }
        },
        computed: {
            typeFlag() {
                let type = this.type.split(',').map(item => item.toLowerCase())
                if (type.indexOf('mp4') != -1 || type.indexOf('m4a') != -1 || type.indexOf('flv') != -1) {
                    return true
                } else {
                    return false
                }
            }
        },
        methods: {
            Addgroupcancel() {
                this.group_form = {}
                this.$refs.submitForm.resetFields()
                this.visibleAddimg = false
            },
            handleAddgroupOk() {
                this.$refs.submitForm.validateFields().then(() => {
                    AddGroup({
                        data: {
                            ...this.group_form
                        },
                        toast: true
                    }).then(() => {
                        this.Addgroupcancel()
                        this.getGroupCate(false)
                    })
                })
            },
            setGroup(data) {
                this.group_form = JSON.parse(JSON.stringify(data))
                this.group_form.group_id = this.group_form.group_id == 0 ? 'all' : this.group_form.group_id
                this.visibleGroup = true
            },
            handleGroupCancel() {
                this.$refs.group_ref.resetFields()
                this.group_form = {}
                this.visibleGroup = false
            },
            handleGroupOk() {
                this.$refs.group_ref.validateFields().then(() => {
                    editFile({
                        data: {
                            id: this.group_form.id,
                            file_id: this.group_form.id,
                            group_id: this.group_form.group_id == 'all' ? 0 : this.group_form.group_id
                        },
                        toast: true
                    }).then(() => {
                        this.handleGroupCancel()
                        setTimeout(() => {
                            this.imageList(this.page)
                        }, 600)
                    })
                })
            },
            // 判断是否选中
            determineFun(data) {
                let arr = this.urlArr.filter(item => data.id == item.id)
                if (arr.length > 0) {
                    return true
                } else {
                    return false
                }
            },
            openModal(group_id = '') {
                if (this.disabled) {
                    return false
                }
                if (group_id && (typeof group_id == 'string' || typeof group_id == 'number')) {
                    this.group_id = [group_id]
                }
                this.getGroupCate()
                this.visible = true
            },
            getGroupCate(type = true) {
                getGroupCate({
                    loading: false
                }).then(res => {
                    res.list.forEach(item => {
                        if (item.value == '') {
                            item.value = 'all'
                        }
                    })
                    this.groupList = res.list
                    this.group_id = this.group_id[0] ? this.group_id : [res.list[0].value]
                    this.imageList()
                })
            },
            handleClick(e) {
                this.group_id = [e.key]
                this.imageList(1)
            },
            imageList(page = 1) {
                imageList({
                    data: {
                        keyword: this.keyword,
                        page: page,
                        type: this.type,
                        group_id: this.group_id[0] == 'all' ? '' : this.group_id[0]
                    }
                }).then(res => {
                    this.data = res.list.data
                    this.pageInfo = {
                        current: res.list.current_page,
                        total: res.list.total,
                        pageSize: res.list.per_page,
                    }
                })
            },
            change(page) {
                this.imageList(page)
            },
            selectImg(data) {
                if (!this.selectAll) {
                    this.image = data.url
                    this.visible = false
                    this.$emit('selectImg', data)
                } else {

                    let arr = this.urlArr.filter(item => data.id == item.id)
                    if (arr.length) {
                        this.urlArr = this.urlArr.filter(item => data.id != item.id)
                    } else {
                        if (this.urlArr.length + this.count == this.number) {
                            return message.warning(`最多选择${this.number}个`);
                        }
                        this.urlArr.push(data)
                    }
                }

            },
            // 文件上传
            customRequest(file) {
                if (this.typeFlag) {
                    const fileName = file.file.name.toLowerCase();
                    if (fileName.endsWith('flv') || fileName.endsWith('mp3') || fileName
                        .endsWith('m4a')) {
                        return this.$methods.message('warning', '请选择视频上传')
                    }
                    this.$store.state.loading_state = true
                    this.$store.state.loading_text = '数据处理中，请稍后。。。'
                    this.ossUpload(file)
                } else {
                    this.fileUploadList.file.push(file.file)
                    this.fileUploadList.uid.splice(this.fileUploadList.uid.indexOf(file.file.uid), 1)
                    if (this.fileUploadList.uid.length == 0) {
                        let arr = []
                        this.fileUploadList.file.forEach(item => {
                            arr.push(this.uploadFileMore(item))
                        })
                        Promise.allSettled(arr).then((res) => {
                            let arr = res.filter(item => item.status == 'rejected')
                            if (arr.length) {
                                message.error(`文件“${arr.map(item=>item.reason).join('、')}”上传失败`)
                            } else {
                                message.success('文件上传成功')
                            }
                            this.imageList()
                            this.$store.state.loading_state = false;
                            this.$store.state.loading_text = ''
                            this.fileUploadList = {
                                file: [],
                                uid: []
                            }
                        })
                    }
                    // uploadFile({
                    //     data: {
                    //         file: file.file,
                    //         allow_exts: this.type.split(','),
                    //         group_id: this.group_id[0] == 'all' ? '' : this.group_id[0]
                    //     },
                    //     toast: true
                    // }).then(res => {
                    //     this.imageList()
                    // })
                }
            },
            uploadFileMore(file) {
                return new Promise((resolve, reject) => {
                    uploadFile({
                        data: {
                            file,
                            allow_exts: this.type.split(','),
                            group_id: this.group_id[0] == 'all' ? '' : this.group_id[0]
                        },
                        loading: false,
                        errToast: false,
                        toast: false
                    }).then((res) => {
                        resolve()
                        // reject(file.name)
                    }).catch(err => {
                        reject(file.name)
                    })
                })
            },
            handleChange({
                fileList
            }) {
                this.$store.state.loading_state = true;
                this.$store.state.loading_text = '正在上传...';
                this.fileUploadList = {
                    file: [],
                    uid: fileList.map(item => item.uid)
                }
            },
            deleteIcon() {
                this.image = '  '
                this.$emit('selectImg', {
                    url: ''
                })
            },
            handleOk() {
                if (this.editorFun) {
                    let url = ''
                    this.urlArr.forEach(item => {
                        // this.editorFun(item.url)
                        url += '<img src="' + item.url + '" />'
                    })
                    this.editorFun.insertHtml(url);
                }
                this.$emit('selectImg', this.urlArr)
                this.visible = false
                this.urlArr = []
            },
            cancel() {
                this.urlArr = []
                this.visible = false
                this.$emit('handlerUploadCancel')
            },
            openModalEditor(fun) {
                if (this.disabled) {
                    return false
                }
                this.editorFun = fun
                if (!this.typeFlag) { // 图片上传
                    this.getGroupCate()
                    this.visible = true
                } else { // 视频上传
                    document.querySelector('.upload_box_components').querySelector('input').click()
                }

            },
            // oss
            ossUpload(file) {
                ossFile({
                    loading: false
                }).then(res => {
                    this.mp4Upload(res, file)
                }).catch(() => {
                    this.$store.state.loading_state = false
                    this.$store.state.loading_text = ''
                })
            },
            mp4Upload(resDate, file) {
                let name = new Date().getTime() + '' + Math.random().toFixed(6).slice(-6)
                let filename = md5(name) + this.getSuffix(file.file.name);
                let formData = new FormData();
                //注意formData里append添加的键的大小写
                formData.append('key', resDate.dir + filename); //存储在oss的文件路径
                formData.append('OSSAccessKeyId', resDate.accessid); //accessKeyId
                formData.append('policy', resDate.policy); //policy
                formData.append('Signature', resDate.signature); //签名
                formData.append("file", file.file);
                formData.append('success_action_status', '200'); //成功后返回的操作码
                axios({
                    url: resDate.host,
                    header: {
                        'Content-Type': 'multipart/form-data'
                    },
                    method: 'post',
                    data: formData,
                    onUploadProgress: (e) => {
                    }
                }).then(res => {
                    this.$store.state.loading_state = false
                    this.$store.state.loading_text = ''
                    this.$methods.message('success', '视频上传成功')
                    this.video = resDate.url + '/' + resDate.dir + filename
                    if (this.editorFun) {
                        this.editorFun.insertElement(CKEDITOR.dom.element.createFromHtml(
                            '<div><video width="100%" controls="controls"><source src="' + this.video +
                            '" type="audio/mp4"></video></div>'));
                    } else {
                        this.captureFirstFrame()
                    }
                }).catch(err => {
                    this.$store.state.loading_state = false
                    this.$store.state.loading_text = ''
                    this.$methods.message('warning', '视频上传失败')
                })
            },
            captureFirstFrame() {
                let that = this
                this.$store.state.loading_state = true
                this.$store.state.loading_text = '正在获取视频第一帧图片，请稍后...'
                let imgbase64 = null;
                let video = document.createElement("video");
                video.setAttribute("crossOrigin", "Anonymous");
                video.setAttribute("src", this.video);
                video.setAttribute("preload", "auto"); // 不设置该项就不会开启预先加载视频，那么拿到的会是黑屏
                //如果不设置currentTime，画出来的图片是空的 当前为截取第0.001秒
                video.currentTime = 0.001;
                // video.onloadeddata = loadedmetadata;
                video.addEventListener("loadeddata", function () {
                    let canvas = document.createElement("canvas");
                    let vWidth = video.videoWidth;
                    let vHeight = video.videoHeight;
                    let whScale = vWidth / vHeight;
                    let widthBg = 512;
                    let heightBg;
                    let splitHeight = 0;
                    if (vWidth < vHeight) {
                        heightBg = 300;
                        // heightBg = vHeight * 512 / vWidth;
                        splitHeight = vHeight / 2 - 150;
                    } else {
                        heightBg = vHeight;
                        // widthBg = heightBg * whScale;
                        // console.log('左右宽的widthBg：', widthBg);
                    }
                    //设置倍数是rate，倍数越大画图的图片越大，加载速度越慢
                    let rate = 1;
                    canvas.width = widthBg * rate;
                    canvas.height = 300;
                    // canvas.height = '100%'
                    canvas
                        .getContext("2d")
                        .drawImage(
                            video,
                            0,
                            splitHeight,
                            vWidth,
                            heightBg,
                            0,
                            0,
                            canvas.width,
                            canvas.height
                        );
                    imgbase64 = canvas.toDataURL("image/png");
                    uploadBaseImage({
                        data: {
                            content: imgbase64
                        },
                        loading: false
                    }).then(res => {
                        that.image = res.upload_data.url
                        that.$emit('selectVideo', {
                            video: that.video,
                            image: that.image
                        })

                    }).finally(() => {
                        that.$store.state.loading_state = false
                        that.$store.state.loading_text = ''
                    })

                })
                video.addEventListener('error', () => {
                    that.$store.state.loading_state = false
                    that.$store.state.loading_text = ''
                    setTimeout(() => {
                        that.$methods.message('warning', '视频文件异常，无法获取第一帧图片')
                    }, 100)
                })
            },
            deleteMp4() {
                this.image = ''
                this.video = ''
                this.$emit('selectVideo', {})
            },
            getSuffix(fileName) {
                let pos = fileName.lastIndexOf(".");
                let suffix = '';
                if (pos != -1) {
                    suffix = fileName.substring(pos);
                }
                return suffix;
            },
            playVideo() {
                let a = document.createElement('a')
                a.href = this.video
                a.target = '_blank'
                a.click()
                a.remove()
            },
        }
    }
</script>

<style lang="less" scoped>
    .upload_box_components {
        overflow: hidden;
        display: inline-block;
        cursor: pointer;

        .up_bx {
            position: relative;

            .upload_text {
                position: absolute;
                top: 80%;
                left: 50%;
                transform: translate(-50%, -50%);
                width: 100%;
                text-align: center;
            }

            .anticon-close-circle {
                z-index: 10;
                position: absolute;
                right: 0;
                top: 0;
                color: #fff;
            }

            .anticon-close-circle:hover {
                color: @redColor;
            }

            :deep(.ant-image-img) {
                height: 100%;
            }
        }
    }

    .select_upload_box {
        .s_u_b_head {
            display: flex;
            align-items: center;
            justify-content: space-between;

            .s_u_b_h_left {
                display: flex;
                align-items: center;

                .ant-btn {
                    margin-left: 20px;
                }
            }

            .s_u_b_h_right {}
        }

        .me_box {
            margin-top: 20px;

            .m_l_menu {
                height: 368px;
                overflow-y: scroll;
            }

            .ant-btn {
                width: 100%;
            }
        }

        .m_l_menu::-webkit-scrollbar {
            width: 0px;
        }

        .s_u_b_contain {
            height: 400px;
            overflow-y: scroll;
            background-color: #f5f5f5;
            padding: 10px;
            flex: 1;
            margin-left: 20px;

            .s_img_box {
                position: relative;
                margin-bottom: 10px;
                margin-right: 10px;
                width: 131px;
                height: 130px;
                border-radius: 5px;
                overflow: hidden;
                cursor: pointer;
                box-sizing: border-box;
                border: 1px solid transparent;
                display: inline-block;

                .is_img {
                    height: 100%;
                    width: 129px;
                }

                .is_t_s {
                    position: absolute;
                    top: 0;
                    left: 0;
                    display: flex;
                    align-items: center;

                    .is_type {
                        margin-right: 5px;
                    }
                }

                span {
                    font-size: 12px;
                    color: #fff;
                    background-color: rgba(79, 79, 79, 70%);
                    display: inline-block;
                    border-radius: 20px;
                    padding: 0 6px;
                    width: fit-content;
                }

                .foot_text {
                    position: absolute;
                    left: 0;
                    bottom: 0;
                    background-color: rgba(79, 79, 79, 70%);
                    width: 100%;
                    white-space: nowrap;
                    /* 保证文本在一行内显示 */
                    overflow: hidden;
                    /* 隐藏溢出的内容 */
                    text-overflow: ellipsis;
                    /* 文字溢出显示省略号 */
                    color: #fff;
                    padding: 0 5px;
                    box-sizing: border-box;
                    font-size: 13px;
                }


                .rount_select {
                    position: absolute;
                    top: -3px;
                    right: 0;

                    .iconfont {
                        color: #999;
                    }

                    .iconfont:hover {
                        color: @color;
                    }

                    display: flex;
                    align-items: center;
                    justify-content: center;
                }

            }

            .s_img_box:hover {
                border-color: @color;
            }

            .s_img_box:nth-of-type(5n) {
                margin-right: 0;
            }

            .s_img_box_select {
                border-color: @color;

                .rount_select {
                    position: absolute;
                    top: -3px;
                    right: 0;

                    display: flex;
                    align-items: center;
                    justify-content: center;

                    // .iconfont {
                    //     color: @color;
                    // }

                }

                .foot_text {
                    background-color: @color;
                }

            }

            .no_data {
                margin-top: 80px;
                display: flex;
                align-items: center;
                flex-direction: column;
                justify-content: center;
                font-size: 16px;
                color: #333;

                img {
                    width: 150px;
                    height: auto;
                }
            }

        }

        .ant-pagination {
            margin-top: 20px;
        }
    }

    .u_b_mask {
        position: absolute;
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, .5);
        top: 0;
        display: flex;
        left: 0;
        align-items: center;
        justify-content: center;
    }

    .icon-bofang {
        color: #fff;
        font-size: 18px;
        cursor: pointer;
    }
</style>